module.exports = __webpack_public_path__ + "img/noises-18.b4dc0242.jpg";